/**
 * CVC validator — validates CVC length by card brand.
 *
 * AMEX requires 4 digits, all other brands require 3 digits.
 *
 * Requirements: 10.5
 */
import type { CardBrand } from "./BrandDetector";

export const CVCValidator = {
  /**
   * Validate CVC string for a given brand.
   * Returns true if the CVC is all digits and has the correct length for the brand.
   * If brand is null, accepts 3 or 4 digit CVCs.
   */
  isValid(cvc: string, brand: CardBrand | null): boolean {
    if (!/^\d+$/.test(cvc)) return false;

    const expectedLength = brand === "AMEX" ? 4 : 3;

    if (brand === null) {
      return cvc.length === 3 || cvc.length === 4;
    }

    return cvc.length === expectedLength;
  },
};
